'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialMarkdown = function IoSocialMarkdown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 7.5c1.4 0 2.5 1.1 2.5 2.5v20c0 1.4-1.1 2.5-2.5 2.5h-30c-1.4 0-2.5-1.1-2.5-2.5v-20c0-1.4 1.1-2.5 2.5-2.5h30z m-12.8 20v-15h-4.4l-3.3 5.3-3.2-5.3h-4.4v15h4.4v-7.5l3.2 4.2 3.3-4.2v7.5h4.4z m6.6 0l5.4-7.5h-3.3v-7.5h-4.3v7.5h-3.3z' })
        )
    );
};

exports.default = IoSocialMarkdown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-markdown.js
// module id = 2458
// module chunks = 0